import React from 'react';
import { cn } from './lib/utils';

/* Section title inside form grids — parity with legacy
   `~co/common/form` Title (data-is-title, spans the grid). */
export function Title({ className, ...props }) {
  return (
    <div
      {...props}
      data-is-title
      className={cn(
        'col-span-full flex min-h-[var(--button-height)] items-center text-[length:var(--title-font-size)] font-semibold text-foreground',
        className,
      )}
    />
  );
}
